import { Report } from 'Services/Api/Reports/Types';

type EditReportHeadingProps = Pick<Report, 'name'>;
const EditReportHeading = ({ name }: EditReportHeadingProps) => <>{name}</>;

export default EditReportHeading;
